import React from 'react'
import { ExportButton } from '../../../../itrust_common/components/others'
import { connect } from 'react-redux'

function ClaimFormDownload(props) {
  const { rpaClaimFormId, orderId, claimFormId, inModal } = props
  const activeClaimFormId = rpaClaimFormId || claimFormId
  const buttonClass = inModal
    ? 'btn btn-outline-primary text-nowrap my-0'
    : 'btn btn-outline-primary my-lg-0 my-md-2 ml-md-5'
  const downloadParams = {
    ['Store-Id']: localStorage.getItem('StoreID'),
    rpa_claim_id: rpaClaimFormId ?? null,
  }
  const downloadPath = activeClaimFormId
    ? `/v1/orders/${orderId}/insurance_claim_forms/${activeClaimFormId}/download_form`
    : `/v1/orders/${orderId}/insurance_claim_forms/download_form`

  if (inModal) {
    return (
      <div className="dropdown d-inline-block ml-md-3">
        <button
          className={`${buttonClass} dropdown-toggle`}
          type="button"
          data-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="false"
        >
          Download
        </button>
        <div className="dropdown-menu border-0 shadow rounded my-3 py-0">
          <ExportButton
            label="Download PDF"
            className="dropdown-item py-3"
            path={downloadPath}
            params={{ ...downloadParams, format: 'pdf', with_background: true }}
          />
          <ExportButton
            label="Download Text PDF"
            className="dropdown-item py-3"
            path={downloadPath}
            params={{ ...downloadParams, format: 'pdf', with_background: false }}
          />
          <ExportButton
            label="Download .txt"
            className="dropdown-item py-3"
            path={downloadPath}
            params={{ ...downloadParams, format: 'text' }}
          />
        </div>
      </div>
    )
  }

  return (
    <>
      <ExportButton label="Download" className={buttonClass} path={downloadPath} params={{ ...downloadParams, format: 'pdf', with_background: true }} />
      <ExportButton label="Download Text PDF" className={buttonClass} path={downloadPath} params={{ ...downloadParams, format: 'pdf', with_background: false }} />
      <ExportButton label="Download .txt" className={buttonClass} path={downloadPath} params={{ ...downloadParams, format: 'text' }} />
    </>
  )
}

const mapStateToProps = (state) => {
  const {
    visionInsuranceClaimForm: { editing },
    order: { order },
    claimForm: { insurance_claim_form },
  } = state
  const orderInsurance = order.orders_insurances_attributes?.find(
    (item) => item.id === editing?.orders_insurance_id,
  )

  return {
    rpaClaimFormId: orderInsurance?.visionary_insurance_claim_form_id,
    orderId: order.id,
    claimFormId: orderInsurance?.claim_form_id || insurance_claim_form?.id,
  }
}

export default connect(mapStateToProps)(ClaimFormDownload)
